// extracted by mini-css-extract-plugin
export default {"cls1":"NewsHeader-cls1__e45af05cb09f022562c0","cls2":"NewsHeader-cls2___294a0402dc5e5933617 NewsHeader-cls1__e45af05cb09f022562c0"};